// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const actionTypes = require('constants/actionTypes');

const {
    DOCUMENT_PENDING_REVISION,
    DOCUMENT_TYPE_PASSPORT,
} = require('constants/accountAddDocumentation');

const addFile = (documentName, side, fileInfo) => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_ADD_FILE,
    payload: {
        documentName,
        fileInfo,
        side,
    },
});

const changeFileName = (documentName, side, name) => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_CHANGE_NAME,
    payload: {
        documentName,
        name,
        side,
    }
});

const getTramitationExpedientFailure = error => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_GET_TRAMITATION_EXPEDIENT_FAILURE,
    payload: {
        error,
    }
});

const getTramitationExpedientRequest = () => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_GET_TRAMITATION_EXPEDIENT_REQUEST,
});

const reset = () => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_GET_TRAMITATION_EXPEDIENT_RESET,
});

const getTramitationExpedientSuccess = (response, userIsFromUE) => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_GET_TRAMITATION_EXPEDIENT_SUCCESS,
    payload: {
        response,
        userIsFromUE,
    }
});

const removeFile = (documentName, side) => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_REMOVE_FILE,
    payload: {
        documentName,
        side,
    },
});

const retryUploadDocumentation = () => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_RETRY_UPLOAD,
});

const uploadDocumentationFailure = error => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_UPLOAD_FAILURE,
    payload: {
        error,
    }
});

const uploadDocumentationRequest = () => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_UPLOAD_REQUEST,
});

const uploadDocumentationSuccess = () => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_UPLOAD_SUCCESS,
});

const setErrorFile = (documentName, side) => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_SET_ERROR_FILE,
    payload: {
        documentName,
        side,
    }
});

const setDoneFiles = documentName => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_SET_DONE_FILES,
    payload: {
        documentName,
    }
});

const setAccountInfo = accountInfo => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_SET_ACCOUNT_INFO,
    payload: {
        accountId: accountInfo.accountId,
        accountNumber: accountInfo.accountNumber,
        alias: accountInfo.alias || '',
        expedientNumber: accountInfo.expedientNumber,
        hasOneHolder: accountInfo.hasOneHolder || false,
        subtype: accountInfo.subtype,
    }
});

const updateTramitationFlagsError = () => ({
    type: actionTypes.ACCOUNT_ADD_DOCUMENTATION_TRAMITATION_FLAG_FAILURE,
});

const getTramitationExpedient = expedientNumber => (dispatch, getState) => {
    const countriesList = getState().globalVariables.getIn(['variables', 'parameters', 'union_europea', 'paises'], '');
    const countryBirth = getState().profile.get('paisNacionalidad');
    const userIsFromUE = countriesList.split(',').includes(countryBirth);
    const requestData = {
        query: {
            limitOnlyLogged: true,
        }
    };
    dispatch(getTramitationExpedientRequest());

    return APIGet({
        dispatch,
        params: requestData,
        url: apiURLBuilder.getURL('tramitationExpedient', {expedientNumber}),
    })
    .then(response => dispatch(getTramitationExpedientSuccess(response, userIsFromUE)))
    .catch(response => {
        if (!!response.error.description) {
            dispatch(getTramitationExpedientFailure(response.error.description));
        } else {
            throw response;
        }
    });
};

const createPromise = files => (dispatch, getState) => {
    const immAccountAddDocumentation = getState().accountAddDocumentation;
    const immProfile = getState().profile;

    return APIPost({
        dispatch,
        endpoint: 'accountUploadDocumentation',
        params: {
            header: {
                version: 2,
            },
            query: {
                files,
                userData: {
                    accountNumber: immAccountAddDocumentation.get('accountNumber'),
                    expedientNumber: immAccountAddDocumentation.get('expedientNumber'),
                    name: immProfile.get('nombreCliente'),
                    surname: immProfile.getIn(['apellidoUno', 'apellido']),
                },
            },
        }
    });
}

const getFiles = (immFile, immAccountAddDocumentation) => {
    let files = [{
        file: immFile.getIn(['front', 'file']),
        fileComments: immFile.get('comments'),
        fileName: immFile.getIn(['front', 'name']),
        tramitationFlag: immFile.get('flag'),
        tramitationIndex: 1,
        tramitationStatus: DOCUMENT_PENDING_REVISION,
    }];

    if (!!immFile.getIn(['back', 'file']) && immAccountAddDocumentation.get('documentTypeForm') !== DOCUMENT_TYPE_PASSPORT) {
        files.push({
            file: immFile.getIn(['back', 'file']),
            fileComments: immFile.get('comments'),
            fileName: immFile.getIn(['back', 'name']),
            tramitationFlag: immFile.get('flag'),
            tramitationIndex: 2,
            tramitationStatus: DOCUMENT_PENDING_REVISION,
        });
    }

    return files;
}

const checkFilesUploaded = (files) => {
    let filesOk = 0;
    files.forEach(file => {
        if (file.status === 'OK') {
            filesOk++;
        }
    });

    return filesOk === files.length;
};

const updateTramitationFlags = (allPromisesOk) => (dispatch, getState) => {
    const immAccountAddDocumentation = getState().accountAddDocumentation;
    const immDocFiles = immAccountAddDocumentation.get('files');
    const expedientNumber = immAccountAddDocumentation.get('expedientNumber');
    let flags = [];

    if (immDocFiles.getIn(['document', 'isVisible']) && immDocFiles.getIn(['document', 'done'])) {
        flags.push({
            status: 'RVP',
            type: 'documento',
        });
    }
    
    if (immDocFiles.getIn(['receipt', 'isVisible']) && immDocFiles.getIn(['receipt', 'done'])) {
        flags.push({
            status: 'RVP',
            type: 'recibo',
        });
    }
    
    if (immDocFiles.getIn(['daal', 'isVisible']) && immDocFiles.getIn(['daal', 'done'])) {
        flags.push({
            status: 'RVP',
            type: 'daal',
        });
    }

    const requestData = {
        query: {
            flags,
        },
    };

    return APIPost({
        params: requestData,
        dispatch,
        url: apiURLBuilder.getURL('tramitationExpedient', {expedientNumber}),
    })
    .then(() => {
        if (allPromisesOk) {
            dispatch(uploadDocumentationSuccess());
        } else {
            dispatch(uploadDocumentationFailure('rejected'));
        }
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(updateTramitationFlagsError());
        } else {
            throw response;
        }
    });
}

const uploadDocumentation = () => (dispatch, getState) => {
    const immAccountAddDocumentation = getState().accountAddDocumentation;
    const immFileDaal = immAccountAddDocumentation.getIn(['files', 'daal']);
    const immFileReceipt = immAccountAddDocumentation.getIn(['files', 'receipt']);
    const immFileDocument = immAccountAddDocumentation.getIn(['files', 'document']);
    let promises = [];

    if (!immFileDaal.get('done') && !!immFileDaal.getIn(['front', 'file'])) {
        const daalFiles = getFiles(immFileDaal, immAccountAddDocumentation);
        const promiseDaal = dispatch(createPromise(daalFiles))
        .then(response => {
            if (checkFilesUploaded(response.files)) {
                dispatch(setDoneFiles('daal'));
            } else {
                dispatch(setErrorFile('daal'));
                throw response;
            }
        })
        .catch(error => {
            dispatch(setErrorFile('daal'));
            throw error;
        });
        promises.push(promiseDaal);
    }

    if (!immFileReceipt.get('done') && !!immFileReceipt.getIn(['front', 'file'])) {
        const receiptFiles = getFiles(immFileReceipt, immAccountAddDocumentation);
        const promiseReceipt = dispatch(createPromise(receiptFiles))
        .then(response => {
            if (checkFilesUploaded(response.files)) {
                dispatch(setDoneFiles('receipt'));
            } else {
                dispatch(setErrorFile('receipt'));
                throw response;
            }
        })
        .catch(error => {
            dispatch(setErrorFile('receipt'));
            throw error;
        });
        promises.push(promiseReceipt);
    }

    if (!immFileDocument.get('done') && !!immFileDocument.getIn(['front', 'file']) &&
        (!!immFileDocument.getIn(['back', 'file']) || immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_PASSPORT)
    ) {
        const documentFiles = getFiles(immFileDocument, immAccountAddDocumentation);
        const promiseDocument = dispatch(createPromise(documentFiles))
        .then(response => {
            if (checkFilesUploaded(response.files)) {
                dispatch(setDoneFiles('document'));
            } else {
                dispatch(setErrorFile('document'));
                throw response;
            }
        })
        .catch(error => {
            dispatch(setErrorFile('document'));
            throw error;
        });
        promises.push(promiseDocument);
    }

    if (promises.length > 0) {
        dispatch(uploadDocumentationRequest());
        const reflect = promise => promise.then(response => ({response, status: 'fulfilled' }),
                                error => ({error, status: 'rejected' }));
        return Promise.all(promises.map(reflect))
            .then(response => {
                let fullFilledSize = 0;
                response.map(resp => {
                    if (resp.status === 'fulfilled') {
                        fullFilledSize++;
                    }
                });

                const allPromisesOk = fullFilledSize === response.length;

                if (fullFilledSize > 0) {
                    dispatch(updateTramitationFlags(allPromisesOk));
                } else {
                    dispatch(uploadDocumentationFailure('rejected'));
                }
            });
    }
};

module.exports = {
    addFile,
    changeFileName,
    getTramitationExpedient,
    removeFile,
    reset,
    retryUploadDocumentation,
    setAccountInfo,
    setErrorFile,
    uploadDocumentation,
};
